import { useContext } from "react";

import Table from "components/Table";
import TableContext from "context/table/tableContext";
import { DEVICE_DETAILS_CHANGES_COLUMNS } from "shared/constants/columns";
import {
    ENDPOINT_PATH_SEGMENTS,
    ENDPOINTS,
    ID_TYPE,
    TABLE_NAMES
} from "shared/types/enums";

const Changes = () => {
    const { detailsData } = useContext(TableContext);

    const { imei } = detailsData;

    return (
        <Table
            name={TABLE_NAMES.Changes}
            customResource={`${ENDPOINTS.Devices}/${imei}${ENDPOINT_PATH_SEGMENTS.Changes}`}
            isInnerTable
            isNotSelectable
            hideSearch
            hideFilters
            initialColumns={DEVICE_DETAILS_CHANGES_COLUMNS}
            idType={ID_TYPE.Id}
            sortFromNewest
        />
    );
};

export default Changes;
